import React, { useState, useEffect } from "react";

import Content from "../../../Components/Dashboard/Content/Content";

import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import {
  GetPanels,
  UpdateSpecificSymbolLotSize,
  UpdateServiceOrLotSize,
  UpdateClientServicesLotSize
} from "../../../Service/superadmin.service";
import Swal from "sweetalert2";

const ChatBotPage = () => {
  const [exchSeg, setExchSeg] = useState("NFO");
  const [symbol, setSymbol] = useState("");
  const [quantity, setQuantity] = useState("");

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);


  const [message, setMessage] = useState("");
  const [panels, setPanels] = useState([]);
  const token = JSON.parse(localStorage.getItem("user_details"))?.token;

  const UpdateAllLotSize = async () => {
    let confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will update lot sizes for all services across all panels.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update",
      cancelButtonText: "No, cancel",
    });
    if (!confirm.isConfirmed) {
      return; // User cancelled the action
    }
    setLoading1(true);
    setMessage("");

    try {
      const response = await UpdateServiceOrLotSize(token);
      setLoading1(false);

      if (response.status) {
        setMessage("✅ All lot sizes updated successfully!");
      } else {
        setMessage("⚠️ Failed to update lot sizes. Please try again.");
      }
    } catch (error) {
      setLoading1(false);

      setMessage("❌ Error occurred while updating lot sizes.");
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const payload = {
        exch_seg: exchSeg,
        symbol,
        quantity,
      };

      const response = await UpdateSpecificSymbolLotSize(payload, token);

      if (response.success) {
        setMessage("✅ Quantity and Lot updated successfully!");
      } else {
        setMessage("⚠️ Update failed. Please try again.");
      }
    } catch (error) {
      setMessage("❌ Error occurred while updating data.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const UpdateClientServicesLotSize1 = async () => {

    let confirm = await Swal.fire({
      title: "Are you sure?", 
      text: "This will update lot sizes for all client services across all panels.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update",
      cancelButtonText: "No, cancel",
    });
    if (!confirm.isConfirmed) {
      return; // User cancelled the action
    }


    setLoading2(true);
    setMessage("");

    try {   
      const response = await UpdateClientServicesLotSize(token);
      setLoading2(false);

      if (response.status) {
        setMessage("✅ Client services lot sizes updated successfully!");
      } else {
        setMessage("⚠️ Failed to update client services lot sizes.");
      }
    }catch (error) {
      setLoading2(false);
      setMessage("❌ Error occurred while updating client services lot sizes.");
      console.error(error);
    }
  };



  useEffect(() => {
    const fetchPanels = async () => {
      try {
        const response = await GetPanels(token);
        if (response.status) {
          // Handle the fetched panels if needed
          setPanels(response.data);
        } else {
          console.error("Failed to fetch panels:", response.message);
        }
      } catch (error) {
        console.error("Error fetching panels:", error);
      }
    };
    fetchPanels();
  }, []); // Empty dependency array to run only once on component mount

  return (
    <Content Page_title="Qty Update" button_status={false}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          maxWidth: 1000,
          mx: "auto",
          mt: 6,
          mb: 4,
        }}
      >
        {/* Left Column: Panel List */}
        <Paper
          elevation={2}
          sx={{
            minWidth: 350,
            maxWidth: 1100,
            flex: "0 0 350px",
            p: 2,
            borderRadius: 3,
            background: "#f7f9fc",
            height: "fit-content",
            maxHeight: 520,
            overflow: "auto", // <-- fix: allow both axis scroll if needed
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#1a237e",
              mb: 2,
              textAlign: "center",
              letterSpacing: 1,
            }}
          >
            Panels
          </Typography>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            {" "}
            {/* fix: horizontal scroll for table */}
            <Box
              component="table"
              sx={{
                width: "100%",
                minWidth: 600, // fix: force table to be wide enough for scroll
                borderCollapse: "collapse",
                fontSize: "0.97rem",
                background: "transparent",
              }}
            >
              <Box component="thead">
                <Box component="tr" sx={{ background: "#e3e8f7" }}>
                  <Box
                    component="th"
                    sx={{
                      p: 1,
                      border: "1px solid #e0e0e0",
                      fontWeight: 600,
                    }}
                  >
                    #
                  </Box>
                  <Box
                    component="th"
                    sx={{
                      p: 1,
                      border: "1px solid #e0e0e0",
                      fontWeight: 600,
                    }}
                  >
                    ID
                  </Box>
                  <Box
                    component="th"
                    sx={{
                      p: 1,
                      border: "1px solid #e0e0e0",
                      fontWeight: 600,
                    }}
                  >
                    Panel Name
                  </Box>
                  <Box
                    component="th"
                    sx={{
                      p: 1,
                      border: "1px solid #e0e0e0",
                      fontWeight: 600,
                    }}
                  >
                    Status
                  </Box>
                </Box>
              </Box>
              <Box component="tbody">
                {panels && panels.length > 0 ? (
                  panels.slice(0, 10).map((panel, index) => (
                    <Box
                      component="tr"
                      key={panel._id || panel.id || panel.panel_name}
                    >
                      <Box
                        component="td"
                        sx={{
                          p: 1,
                          border: "1px solid #e0e0e0",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </Box>
                      <Box
                        component="td"
                        sx={{
                          p: 1,
                          border: "1px solid #e0e0e0",
                          color: "#1976d2",
                          fontWeight: 500,
                        }}
                      >
                        {panel._id || panel.id}
                      </Box>
                      <Box
                        component="td"
                        sx={{
                          p: 1,
                          border: "1px solid #e0e0e0",
                          fontWeight: 500,
                        }}
                      >
                        {panel.panel_name}
                      </Box>
                      <Box
                        component="td"
                        sx={{
                          p: 1,
                          border: "1px solid #e0e0e0",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: panel.is_active ? "green" : "red",
                            fontWeight: 600,
                          }}
                        >
                          {panel.is_active ? "Active" : "Inactive"}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box component="tr">
                    <Box
                      component="td"
                      colSpan={4}
                      sx={{
                        color: "#888",
                        textAlign: "center",
                        p: 2,
                      }}
                    >
                      No panels found.
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Paper>
        {/* Right Column: Qty Update Form */}
        <Box sx={{ flex: 1 }}>
          <Paper
            elevation={4}
            sx={{
              borderRadius: 4,
              p: { xs: 3, sm: 4 },
              boxShadow: "0 8px 32px 0px rgba(9,40,163,0.08)",
              background: "#fff",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#1a237e",
                mb: 2,
                textAlign: "center",
                letterSpacing: 1,
              }}
            >
              Update Qty & Lot for{" "}
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                label="Exchange Segment"
                value={exchSeg}
                onChange={(e) => setExchSeg(e.target.value.toUpperCase())}
                placeholder="e.g., NFO, NSE, BSE"
                variant="outlined"
                fullWidth
                required
                sx={{ mb: 2 }}
                inputProps={{ maxLength: 20 }}
              />
              <TextField
                label="Symbol"
                value={symbol}
                onChange={(e) => setSymbol(e.target.value.toUpperCase())}
                placeholder="e.g., AAPL"
                variant="outlined"
                fullWidth
                required
                sx={{ mb: 2 }}
                inputProps={{ maxLength: 20 }}
              />
              <TextField
                label="Quantity"
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                placeholder="e.g., 100"
                variant="outlined"
                fullWidth
                required
                sx={{ mb: 2 }}
                inputProps={{ min: 1 }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                sx={{
                  fontWeight: 600,
                  borderRadius: 2,
                  py: 1.2,
                  fontSize: "1rem",
                  boxShadow: "0 2px 8px rgba(9,40,163,0.07)",
                }}
                disabled={loading}
                startIcon={
                  loading && <CircularProgress size={20} color="inherit" />
                }
              >
                {loading ? "Updating..." : "Update Qty & Lot"}
              </Button>
            </form>
            {message && (
              <Typography
                sx={{
                  mt: 3,
                  textAlign: "center",
                  color: message.startsWith("✅")
                    ? "success.main"
                    : message.startsWith("⚠️")
                    ? "warning.main"
                    : "error.main",
                  fontWeight: 500,
                  fontSize: "1rem",
                  letterSpacing: 0.2,
                }}
              >
                {message}
              </Typography>
            )}
          </Paper>

          <Card
            sx={{
              maxWidth: 500,
              mx: "auto",
              mt: 5,
              p: 2,
              borderRadius: 3,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
            }}
          >
            <CardContent>
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontWeight: 600, mb: 2 }}
                >
                  Update All Lot Sizes for Services
                </Typography>

                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  size="large"
                  sx={{
                    fontWeight: 600,
                    borderRadius: 2,
                    py: 1.2,
                    fontSize: "1rem",
                    boxShadow: "0 2px 8px rgba(9,40,163,0.07)",
                  }}
                  onClick={UpdateAllLotSize}
                  disabled={loading1}
                  startIcon={
                    loading1 && <CircularProgress size={20} color="inherit" />
                  }
                >
                  {loading1 ? "Updating..." : " Update All Lot Sizes"}
                </Button>
              </Box>
            </CardContent>
          </Card>




           <Card
            sx={{
              maxWidth: 500,
              mx: "auto",
              mt: 5,
              p: 2,
              borderRadius: 3,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
            }}
          >
            <CardContent>
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontWeight: 600, mb: 2 }}
                >
                  Update All Lot Sizes for Client Services
                </Typography>

                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  size="large"
                  sx={{
                    fontWeight: 600,
                    borderRadius: 2,
                    py: 1.2,
                    fontSize: "1rem",
                    boxShadow: "0 2px 8px rgba(9,40,163,0.07)",
                  }}
                  onClick={UpdateClientServicesLotSize1}
                  disabled={loading2}
                  startIcon={
                    loading2 && <CircularProgress size={20} color="inherit" />
                  }
                >
                  {loading2 ? "Updating..." : " Update All Lot Client Services"}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Content>
  );
};

export default ChatBotPage;

// There is nothing in this React component that would directly cause a JavaScript heap out of memory issue.
// This file only fetches a small list of panels, renders a form, and calls API endpoints on submit.
// The heap out of memory error you posted earlier is a Node.js backend/server-side error, not a frontend React error.

// If you are seeing heap out of memory in your Node.js backend, check for:
// - Large in-memory arrays or objects (e.g., loading huge datasets into memory).
// - Infinite loops or recursive calls.
// - Not streaming large files or responses.
// - Memory leaks due to event listeners or global variables.

// This frontend file is safe and not related to heap memory issues.
